import { newModal } from "@js/helpers/state.js";
import { CE_MODAL_DOWNLOAD_CONTENT_SHOW } from "@js/actions/studio/campaign_content_section/modal_download_content.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_DOWNLOAD_CONTENT_SHOW:
      return newModal(state, "download_content_modal", {});
    default:
      return state;
  }
};
